import { gql } from "@apollo/client";

export const LIST_CATEGORIES_BY_LOCATION = gql`
  query getAllAssetWithinRange(
    $latitude:Float!
    $longitude:Float!
    $distance:Float!
  ){
    getAllAssetWithinRange(
      latitude:$latitude
      longitude:$longitude
      distance:$distance
    )
    {
      category{
          id, name
        }
    }
  }
`;
